import { useState } from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { WhatsApp } from "@mui/icons-material";
import {
  ArrowLeftIcon,
  ArrowRightIcon,
  ChevronRightIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import { DefaultInput } from "../../inputs/DefaultInput";
import { ColombiaIconInput } from "../../inputs/CoIombiaIconInput";
import { VerifyCellphone } from "./VerifyCellphone";
import { AuthService } from "../../../services/auth/auth.service";
import { PrimaryMobile } from "../../buttons/mobile/Primary";
import { TYPUpdate } from "../../navigation/disclosure/Update/TYPUpdate";
import { Primary } from "../../buttons/Primary";

export function Cellphone() {
  const [open, setOpen] = useState(false);
  const [phoneInput, setPhoneInput] = useState("");
  const [showError, setShowError] = useState(false);
  const [messageError, setMessageError] = useState("");
  const [showViewVerifyOtp, setShowViewVerifyOtp] = useState(false);
  const [showSuccessView, setShowSuccessView] = useState(false);
  const [otpInput, setOptInput] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [disabledBtn, setDisabledBtn] = useState(false);

  const handleChange = (e) => {
    const { value } = e.target;
    setPhoneInput(value);
  };

  const handleClosePanel = () => {
    setOpen(false);
    setPhoneInput("");
    setMessageError("");
    setShowViewVerifyOtp(false);
    setShowError(false);
  };

  const toggleShowViewVerifyOtp = () => {
    setShowViewVerifyOtp(!showViewVerifyOtp);
  };

  const handleSubmitVerifyPhone = async () => {
    if (phoneInput.length < 10) {
      setShowError(true);
      setMessageError("El número debe ser de 10 dígitos.");
      return;
    }
    if (phoneInput === localStorage.getItem("phone")) {
      setShowError(true);
      setMessageError("El número debe ser diferente al que está registrado.");
      return;
    }

    setShowError(false);
    setMessageError("");
    setDisabledBtn(true);
    setIsLoading(true);

    try {
      let { message, error, code } =
        await AuthService.confirmPhoneToUpdatePhone({
          documento: localStorage.getItem("doc"),
          phone: phoneInput,
        });

      if (error) {
        setShowError(true);
        if (code === 500) {
          setMessageError("Ocurrió un error interno, intenta más tarde!");
        }
        if (code === "ERR_BAD_REQUEST") {
          setMessageError(
            "Ocurrió un error. Valida los datos e intenta nuevamente."
          );
        }
        return;
      }

      if (message && message?.success && message.success === true) {
        setShowViewVerifyOtp(true);
        return;
      } else {
        setShowError(true);
        setMessageError(
          "Ocurrió un error interno, Valida los datos e intenta nuevamente."
        );
      }
    } catch (error) {
      console.log(error);
      setShowError(true);
      setMessageError("Ocurrió un error interno, intenta más tarde!");
    } finally {
      setDisabledBtn(false);
      setIsLoading(false);
    }
  };

  const handleSubmitVerifyOtp = async () => {
    if (otpInput.length === 0) {
      setShowError(true);
      setMessageError("Ingrese el otp.");
      return;
    }
    if (otpInput.length < 6) {
      setShowError(true);
      setMessageError("Complete el otp.");
      return;
    }

    setShowError(false);
    setMessageError("");
    setDisabledBtn(true);
    setIsLoading(true);

    try {
      let { message, error, code } = await AuthService.confirmOtpToUpdatePhone({
        documento: localStorage.getItem("doc"),
        newPhone: phoneInput,
        otp: otpInput,
      });
      if (error) {
        console.log(message);
        setShowError(true);
        if (code === 500) {
          setMessageError("Ocurrió un error interno, intenta más tarde!");
        }
        if (code === 400) {
          setMessageError(
            "Ocurrió un error interno, Valida los datos e intenta nuevamente."
          );
        }
        return;
      }

      if (message && message?.success && message.success === true) {
        setShowViewVerifyOtp(false);
        setShowSuccessView(true);
        localStorage.setItem("phone", phoneInput);
        return;
      } else {
        setShowError(true);
        setMessageError(
          "Ocurrió un error interno, Valida los datos e intenta nuevamente."
        );
      }
    } catch (error) {
      console.log(error);
      setShowError(true);
      setMessageError("Ocurrió un error interno, intenta más tarde!");
    } finally {
      setDisabledBtn(false);
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className={"w-full"} onClick={() => setOpen(true)} href="#">
        <div className="cursor-pointer min-w-full">
          <div className="md:w-1/3">
            <div>
              <Primary text="Comenzar" />
            </div>
          </div>
        </div>
      </div>
      <Dialog open={open} onClose={handleClosePanel} className="relative z-50">
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-darkBgLight bg-opacity-75 transition-opacity duration-500 ease-in-out data-[closed]:opacity-0"
        />

        <div className="fixed inset-x-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full md:pl-10">
              <DialogPanel
                transition
                className="pointer-events-auto w-screen md:max-w-sm transform transition duration-300 ease-in-out data-[closed]:translate-x-full"
              >
                <div className="flex h-full flex-col bg-darkBg tracking-tight font-walsheim">
                  <div className="">
                    <div className="py-6 bg-darkBg">
                      <div className="flex justify-between px-4 pt-8 ">
                        <div className="flex h-7 items-center">
                          <button
                            type="button"
                            onClick={handleClosePanel}
                            className="relative text-white focus:outline-none"
                          >
                            <span className="absolute" />
                            <span className="sr-only">Close panel</span>
                            <ArrowLeftIcon
                              aria-hidden="true"
                              className="h-6 w-6"
                            />
                          </button>
                        </div>
                      </div>
                      <div className=" px-4 pt-8 ">
                        <div className="text-white font-bold text-xl">
                          Indicanos tu WhatsApp
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="h-full rounded-t-3xl bg-white p-4">
                    <div className="text-grayP py-4">
                      Te enviaremos un código OTP de 6 dígitos a tu WhatsApp
                      para verificar que esté correcto
                    </div>
                    <div className="flex gap-2">
                      <ColombiaIconInput />
                      <DefaultInput
                        autoFocus={true}
                        type={"tel"}
                        name={"WhatsApp"}
                        id={"WhatsApp"}
                        autoComplete={"on"}
                        spellCheck={true}
                        required={true}
                        minLength={"10"}
                        maxLength={"10"}
                      />
                    </div>

                    <div className="grid justify-items-end pt-8">
                      <div className="grid content-center">
                        <VerifyCellphone />
                      </div>
                    </div>
                  </div>
                </div>
              </DialogPanel>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
}
